export default "__VITE_ASSET__CyrtGe9w__"